import { render, staticRenderFns } from "./MembraneList.vue?vue&type=template&id=23fcce7b&scoped=true&"
import script from "./MembraneList.vue?vue&type=script&lang=js&"
export * from "./MembraneList.vue?vue&type=script&lang=js&"
import style0 from "./MembraneList.vue?vue&type=style&index=0&id=23fcce7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fcce7b",
  null
  
)

export default component.exports